import AddIcon from '@mui/icons-material/Add';

export default AddIcon;
